import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetAggregateStatusRequestModel, GetAggregateStatusResponseModel } from "@/features/accounts/finance/services/aggregate-status-model";

export class AggregateStatusApi {
/**
* アグリゲーション状態取得API
*/
    public getAggregateStatus = async (
        param: GetAggregateStatusRequestModel
    ): Promise<GetAggregateStatusResponseModel> => {
        // pythonのblueprintでは /aggregate/status
        const path = `/api/aggregate/status`;

        const res = await ApiClient.instance.get<GetAggregateStatusResponseModel>({
            path: path,
            params: param as NonNullable<unknown>,
        });

        if (res.ok === false) {
            throw MoneyLinkException.fromServer({ response: res });
        }

        return res.body;
    };
}
